import version from '../../package.json';

export const environment = {
  production: false,
  hmr: false,
  version: version.version + '-dev',
  envName: 'dev',
  environmentName: 'DEV',
  origins: ['https://billing-portal-dev.archinsurance.io'],
  appUrl: 'https://billing-portal-dev.archinsurance.io',
  AIP_AGENCY_ROLE: 'AIGI-ROLE-DIGAIP-AGENCY',
  AIP_ADMIN_ROLE: 'ADMIN',
  aipHostPort: 'http://aigi-drvjbss001:8080/',
  billingPortalApiHost: 'https://billing-portal-api-int.archinsurance.io/api/',
  billingPortalConsumerApiHost: 'https://billing-portal-api-int.archinsurance.io/api-con/',
  bopQuoteEndPoint: 'api/quote',
  paymentUsIframe: 'https://secure4.paymentus.com/xotp/pm/aidc?authToken=',
  paymentUsOrigin: 'https://secure4.paymentus.com',
  postMessagePmDetailsOrigin: {
    agent: 'https://billing-portal-api-dev.archinsurance.io/payer-info',
    consumer: 'https://billing-portal-api-dev.archinsurance.io/direct/payment',
  },
  chaseOrigin: {
    version2: {
      origin: 'https://www.chasepaymentechhostedpay-var.com',
      iframeOrigin: `https://www.chasepaymentechhostedpay-var.com`,
    },
    version3: {
      origin: 'https://chase-var.hostedpaymentservice.net',
      iframeOrigin: `https://chase-var.hostedpaymentservice.net`,
    },
  },

  aipHostPortMenu: 'https://aip-authorization-ms-int.archinsurance.com/',
  chaseCallBackUrl: 'https://billing-portal-int.archinsurance.io/success/',
  hostedChaseCallBackUrl: 'https://billing-portal-int.archinsurance.io/hosted/success/',
  aipHostPortAdmin: 'https://aip-admin-api-int.archinsurance.io/',
  aipHostPortBase: 'https://aip-base-api-int.archinsurance.io',
  aipHostPort1: 'https://aip-base-api-int.archinsurance.com/aip-base-api/aip-base-api',
  aipHostPort2: 'https://aip-authorization-ms-int.archinsurance.io',
  pgrRedirectUrl: 'aHR0cHM6Ly9xYS5idXNpbmVzc3F1b3RlLnByb2dyZXNzaXZlY29tbWVyY2lhbC5jb20vYXJjaGNvbmZpcm1hdGlvbg==', //default redirectUrl for Progressive.

  //ROLE
  internal: 'ARCH',
  external: 'AGENCY',
  admin: 'ADMIN',
  internalUser: 'Internal',
  externalUser: 'External',
  INTERNAL_EMAIL_DOMAIN: [
    'archinsurance.com',
    'archgroup.com',
    'archcapservices.com',
    'archgso.com',
    'corp.archcapservices.com',
  ],
  SKIP_PORTALS_INTERNAL_USER: ['AIGI-BasePortal'],
  AUTO_PORTALS_INTERNAL_USER: [{ 'AIGI-BasePortal': 'AIGI-ROLE-DIGAIP-ARCH-UNDERWRITER' }],
  LAUNCHDARKLY_CLIENTID: '635fd8a8f772dc0bdb58c32d',
};
